export default "__VITE_ASSET__VqD2sdYG__"